import React from 'react';
import { Link } from "react-router-dom";
import homeimage from './assets/images/homepage-image.jpg';
import moon from './assets/images/moon.svg';
import archie from './assets/images/archie-thumb.jpg';
import brizo from './assets/images/brizo-thumb.jpg';
import makara from './assets/images/makara/makara-thumb.jpg';
import quinn from './assets/images/quinn/quinn-thumb.jpg';
import juno from './assets/images/juno-thumb.jpg';
import storm from './assets/images/storm/storm-thumb.jpg';
import yami from './assets/images/yami/yami-thumb.jpg';
import hades from './assets/images/hades/hades-thumb.jpg';
import enzo from './assets/images/enzo/enzo-thumb.jpg';
import eevee from './assets/images/eevee/eevee-thumb.jpg';
import ckc from './assets/images/luna-cert.jpg';
import silverckc from './assets/images/silverspring-ckc.jpg';

class Home extends React.Component {
  componentDidMount() {
    window.scrollTo(0, 0);
  }

  render() {
    return (
      <div className="homepage-container">
        <div className="homepage content">
          <div className="main">
            <img src={homeimage} alt="LunaNova" className="feature-image" />
            <h1>Welcome to LunaNova</h1>
            <p className="headline">At LunaNova, we strive to breed loving family pets.<br />We are a small, home-based, family-oriented breeder located on a beautiful acre of property in Cambridge, Ontario.</p>
            <p>LunaNova has been seriously committed to breeding healthy, well-tempered, intelligent puppies since 2011</p>
            <p>Our pups are born in the "puppy nursery" area on the top level of our home, and are kept under 24/7 supervision for the first few delicate weeks of their lives.  The "puppy nursery" room is specifically set up to ensure that the newborns, and their mother, thrive during the critical neonate puppy stages.  This includes doing Early Neurological Stimulation (ENS) and Early Scent Introduction exercises with the pups, which enhances neurological development and improves the pups' ability to cope with stressors throughout their lives.</p>
            <p>Once they are 4 weeks old, they graduate to a spacious designated puppy area on the lower level of our home that was designed to ensure the pups have all the mental and physical stimulation they need to develop into smart, strong, and confident pups.  This includes exposure to many different sounds, lights, surfaces, toys and experiences; and also generous amounts of time spent immersed in interactions with adults, children, and older dogs.</p>
            <p>At our house, there is little distinction between humans and dogs as important family members, and the breeding and rearing of pups at LunaNova is truly a family affair!</p>
            <p>Our puppies come from generations of home-bred Canadian-Championed Mothers, and home-bred or established Canadian and/or American-Championed Fathers, all who descend from multiple generations of Championship bloodlines! Our adult dogs have comprehensive health clearances, and are known for the health, temperament, structure and trainability of their offspring.</p>
            <p><i>Our goal is to place all our puppies in FOREVER homes where people understand the amount of time and commitment it takes to raise a well-behaved, well-socialized dog.</i></p>
            <p><Link to="/about">Learn more about LunaNova</Link></p>
            <blockquote>I am the caretaker not only of the individual dog, but of the reputation and welfare of the breed as a whole.<br /><br />It is incumbent upon me to set the example of each dog being individually cherished, but only the physically and temperamentally sound being bred.<br /><br />I accept the premise that if I breed a litter, those dogs are my responsibility throughout their entire lifetime.<br /><br />
              - Preservation Breeders' Oath</blockquote>
            <div className="divider">
              <img src={moon} alt="LunaNova moon" className="moon" />
            </div>
            <h2>About Portuguese Water Dogs</h2>
            <p>Overall, Portuguese Water Dogs are a spirited, robust swimmer and diver; loyal and alert. The Portuguese Water Dog is intelligent and quite easy to train. He learns new commands quickly at an above average rate. Portuguese Water Dogs are social and interactive dogs, known for their athleticism and high energy. According to the Canadian Kennel Club, Portuguese Water Dogs require daily vigorous exercise and respond well to training.</p>
            <p>The Portuguese Water Dog is a hypoallergenic breed. They grow and lose hair much like a human does, and require frequent grooming. However, a very small percentage of people with severe allergies will still have a reaction to this breed.  So it is important, if anyone in your family suffers from dog allergies, to visit.  In order to kiss, hug and pet the dogs, to make sure that the PWD does not cause an allergic reaction.</p>
            <table className="simple-table styled-table">
              <thead>
                <tr>
                  <th></th>
                  <th>Height</th>
                  <th>Weight</th>
                </tr>
              </thead>
              <tbody>
                <tr className="male">
                  <td><strong>Male</strong></td>
                  <td>19.5 - 22.5"</td>
                  <td>42 - 60 lbs</td>
                </tr>
                <tr className="female">
                  <td><strong>Female</strong></td>
                  <td>16.5 - 20.5"</td>
                  <td>35 - 50 lbs</td>
                </tr>
              </tbody>
            </table>
            <p><a href="https://www.ckc.ca/en/Choosing-a-Dog/Choosing-a-Breed/Working-Dogs/Portuguese-Water-Dog" target="_blank" rel="noopener noreferrer">Learn more about Portuguese Water Dogs</a></p>
          </div>
          <div className="side">
            <div className="section">
              <h2>Puppies Available</h2>
              <p>We will have puppies ready for forever homes Summer 2026 and Fall 2026! Click below to learn more!</p>
              <Link to="/adoptions" className="call-to-action big shadow">
                <span>Adopt a Puppy</span>
              </Link>
              <p>If you send us an application or email, and do not get a reply, please check your spam folder. As we ALWAYS reply! Unfortunately sometimes our replies do end up in peoples junk folders!</p>
            </div>
            <div className="section">
              <h2>More about PWDs</h2>
              <p>We believe that Portuguese Water Dogs are a unique and special breed.</p>
              <p>If you are interested in a PWD, we ask that you <a href="http://pwdcc.org/" target="_blank" rel="noopener noreferrer">do some research on the breed</a>.</p>
            </div>
            <div className="section social">
              <h2>More LunaNova</h2>
              <p>Check out our past litters on <a href="https://www.youtube.com/user/LUNANOVAPWDS" target="_blank" rel="noopener noreferrer"><i className="fab fa-youtube"></i> YouTube (legacy)</a><br />
                Follow us on <a href="https://www.instagram.com/lunanovapwds/" target="_blank" rel="noopener noreferrer"><i className="fab fa-instagram"></i> Instagram</a></p>
            </div>
            <div className="section">
              <h2>CKC Registered</h2>
              <p>LunaNova and Silverspring are registered through the Canadian Kennel Club.</p>
              <img src={ckc} alt="LunaNova Canadian Kennel Club certificate" className="thumb" />
              <img src={silverckc} alt="Silverspring Canadian Kennel Club certificate" className="thumb" />
            </div>
          </div>
        </div>
        <div className="homepage-footer content">
          <div className="divider">
            <img src={moon} alt="LunaNova moon" className="moon" />
          </div>
          <h2 className="centered">The Dogs</h2>
          <div className="dog-features">
            <Link to="/dogs/archie" className="dog">
              <img src={archie} alt="LunaNova Archie" />
              <span className="male">Archie</span>
            </Link>
            <Link to="/dogs/brizo" className="dog">
              <img src={brizo} alt="LunaNova Brizo" />
              <span className="female">Brizo</span>
            </Link>
            <Link to="/dogs/enzo" className="dog">
              <img src={enzo} alt="LunaNova Enzo" />
              <span className="male">Enzo</span>
            </Link>
            <Link to="/dogs/eevee" className="dog">
              <img src={eevee} alt="LunaNova Eevee" />
              <span className="female">Eevee</span>
            </Link>
            <Link to="/dogs/hades" className="dog">
              <img src={hades} alt="LunaNova Hades" />
              <span className="male">Hades</span>
            </Link>
            <Link to="/dogs/juno" className="dog">
              <img src={juno} alt="LunaNova Juno" />
              <span className="female">Juno</span>
            </Link>
            <Link to="/dogs/makara" className="dog">
              <img src={makara} alt="LunaNova Makara" />
              <span className="female">Makara</span>
            </Link>
            <Link to="/dogs/quinn" className="dog">
              <img src={quinn} alt="LunaNova Quinn" />
              <span className="female">Quinn</span>
            </Link>
            <Link to="/dogs/storm" className="dog">
              <img src={storm} alt="LunaNova Storm" />
              <span className="female">Storm</span>
            </Link>
            <Link to="/dogs/yami" className="dog">
              <img src={yami} alt="LunaNova Yami" />
              <span>Yami</span>
            </Link>
          </div>
        </div>
      </div>
    );
  }
}

export default Home;
